import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useState } from "react";
import classNames from "classnames";
import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";
import styles from "./Card.module.scss";
const getContent = ({ isCollapsibleSeperator = false, children, }) => {
    if (!children)
        return null;
    return (_jsx("div", { className: classNames(styles.content, {
            [styles.collapsibleSeperator]: isCollapsibleSeperator,
        }), children: children }));
};
export const Card = forwardRef(({ title, subcontent, children, variant = "variant1", isCollapsible = false, isCollapsibleSeperator = false, collapsed = false, onToggle, nonCollapsibleContent, id, titleDataTestId, description, pending, ...restProps }, ref) => {
    const [isCardCollapsed, setIsCardCollapsed] = useState(collapsed);
    const toggle = useCallback(() => (onToggle ? onToggle() : setIsCardCollapsed(!isCardCollapsed)), [onToggle, setIsCardCollapsed, isCardCollapsed]);
    const isCollapsed = onToggle ? collapsed : isCardCollapsed;
    const handleClick = isCollapsible ? toggle : undefined;
    return (_jsxs("div", { ...restProps, "data-variant": `card-${variant}`, className: classNames(styles.container, styles[`variant-${variant}`], {
            [styles.pending]: pending,
        }), id: id, ref: ref, children: [(title || description || subcontent || isCollapsible) && (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.textContent, children: [title && (_jsx("div", { className: styles.title, "data-testid": titleDataTestId ?? "", children: title })), description && _jsx("div", { className: styles.description, children: description })] }), _jsxs("button", { className: classNames(styles.subtitleWrapper, {
                            [styles.collapsible]: isCollapsible,
                        }), onClick: handleClick, children: [subcontent && _jsx(_Fragment, { children: subcontent }), isCollapsible && (_jsx("div", { className: styles.icons, children: isCollapsed ? (_jsx(ChevronDownIcon, { className: styles.icon })) : (_jsx(ChevronUpIcon, { className: styles.icon })) }))] })] })), getContent({
                children: nonCollapsibleContent,
            }), !isCollapsed &&
                getContent({
                    children,
                    isCollapsibleSeperator,
                })] }));
});
//# sourceMappingURL=Card.js.map